/**
 * 应用配置
 */

const CONFIG_BASE = {
    // html的tite
    htmlTitle: 'Admin - {title}'
  }
  
  // 开发配置
  const CONFIG_DEV = {
    // domain: 'http://dev-api-docs.tradplusad.com'
    domain: 'http://test-docs-admin.tradplusad.com/api'
  }
  
  // 测试配置
  const CONFIG_TEST = {
    domain: 'http://dev-api.doc.tradplus.com'
  }
  
  // 生产配置
  const CONFIG_PRO = {
    domain: '/api'
  }
  
  const ENV_CONFIG_MAP = {
    development: CONFIG_DEV,
    test: CONFIG_TEST,
    production: CONFIG_PRO
  }
type Env = 'development' | 'test' | 'production'

  const env: Env = (process.env.REACT_APP_ENV_CONFIG || process.env.NODE_ENV) as Env


  const CONFIG = { ...CONFIG_BASE, ...ENV_CONFIG_MAP[env] }
  
  export default CONFIG